import React from "react";
import { StyledV2Footer } from "./styled";
import { useSelector } from "react-redux";
import { getMerchantConfig } from "features/config/configSlice";
import { useTranslation } from "react-i18next";

function V2Footer({ stickyBottom = false }) {
  const merchantConfig = useSelector(getMerchantConfig);
  const { t } = useTranslation();

  return (
    <StyledV2Footer stickyBottom={stickyBottom}>
      {stickyBottom && merchantConfig.whatsapp_help && (
        <a
          href={merchantConfig.whatsapp_help}
          target="_blank"
          rel="noreferrer"
          className="footer-help"
        >
          {t("footer.needHelp")}
        </a>
      )}
      <span className="footer-powered">
        {t("footer.poweredBy")}
        <a
          href="https://bepragma.ai/?utm_source=RMS&utm_medium=entrypage&utm_campaign=footer"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://pragma-staticfiles-prod.s3.amazonaws.com/static/metronic/assets/media/logos/pragma-default-light.svg"
            alt="PRAGMA."
          />
        </a>
      </span>
    </StyledV2Footer>
  );
}

export default V2Footer;
